import React, { useState, useEffect } from "react";
import { Tooltip, message } from "antd";
import { Link } from "react-router-dom";
import StatusBadge from "../../Reuseable/StatusBadge";
import LeaveTypeService from "../../../Services/LeavetypeService";
import DataParser from "../../../utlits/Dataparser";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import { Helmet } from "react-helmet";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const LeaveType = () => {
  const [leaveTypeList, setLeaveTypeList] = useState([]);
  const [userPermissions, setuserPermissions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [status, setStatus] = useState(true);
  const [name, setName] = useState("");
  const [isEntitlementSituation, setIsEntitlementSituation] = useState(false);
  const [editStatus, setEditStatus] = useState(null);
  const [editName, setEditName] = useState("");
  const [error, setError] = useState("");
  const [isEditEntitlementSituation, setIsEditEntitlementSituation] = useState(null);
  const [editID, setEditID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const compid = DataParser.CompanyId();

  useEffect(() => {
    getAllLeaveType();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    SocketService.connect();
    const companyId = DataParser.CompanyId();
    const handleLeaveTypeUpdate = (data) => {
      if (Number(data.company_id) === Number(companyId)) {
        getAllLeaveType();
      }
    };
    SocketService.on("leavetype_update", handleLeaveTypeUpdate);
    return () => {
      SocketService.off("leavetype_update", handleLeaveTypeUpdate);
    };
  }, []);

  useEffect(() => {
    if (pageSize > 15) {
      setCurrentPage(1);
    }
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const getAllLeaveType = () => {
    setLoading(true);
    LeaveTypeService.getLeaveType(compid)
      .then((res) => {
        const Data = res.data.leavetypes;
        setLeaveTypeList(Data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onStatusChange = () => setStatus(!status);
  const onEditStatusChange = () => setEditStatus(!editStatus);

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteLeaveTypeModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const newArray = leaveTypeList.filter((s) => s.id !== itemToDelete.id);
    setLeaveTypeList(newArray);
    document.getElementById("closeLeaveTypeDeleteModal").click();
    try {
      await LeaveTypeService.deleteLeaveType(itemToDelete.id);
      message.success("Leave type deleted successfully!");
      getAllLeaveType();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete leave type. Please try again!");
      getAllLeaveType();
    }
    setItemToDelete(null);
  };

  const handelEdit = (e, item) => {
    setEditStatus(item.status === "1" || item.status === 1);
    setIsEditEntitlementSituation(item.isEntitlementSituation);
    setEditName(item.name);
    setEditID(item.id);
    setError("");
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (!editName || editName.trim() === "") {
      setError("Leave type name is required!");
      return;
    }

    const Data = {
      id: editID,
      company_id: compid,
      name: editName.trim(),
      status: editStatus ? "1" : "0",
      situational: isEditEntitlementSituation,
    };

    LeaveTypeService.editLeaveType(Data)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }
        if (res.Good === true) {
          message.success("Leave type updated successfully!");
          const link = document.getElementById("editmodalclose");
          if (link) link.click();
          getAllLeaveType();
        } else {
          message.warning("Failed to update leave type. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Edit leave type error:", err);
        message.error(
          err.response?.data?.message ||
          "An error occurred while updating the leave type."
        );
      });
  };

  const handelCreate = (e) => {
    e.preventDefault();

    if (!name || name.trim() === "") {
      setError("Leave type name is required!");
      return;
    }

    const Data = {
      company_id: compid,
      name: name.trim(),
      situational: isEntitlementSituation,
    };

    LeaveTypeService.createLeaveType(Data)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          return;
        }
        if (res.Good === true) {
          message.success("Leave type created successfully!");
          const link = document.getElementById("createmodalclose");
          if (link) link.click();
          setName("");
          setIsEntitlementSituation(false);
          getAllLeaveType();
        } else {
          message.warning("Failed to create leave type. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Create leave type error:", err);
        message.error(
          err.response?.data?.message ||
          "An error occurred while creating the leave type."
        );
      });
  };

  const clearCreateState = () => {
    setName("");
    setIsEntitlementSituation(false);
    setError("");
  };

  const clearEditState = () => {
    setEditName("");
    setEditStatus(true);
    setIsEditEntitlementSituation(null);
    setEditID(null);
    setError("");
  };

  const PaginatedData = paginate(leaveTypeList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Leave Types - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Leave Types</li>
                    </ol>
                    {userPermissions.indexOf("leavetype-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createLeaveTypeModal"
                      >
                        Create Leave Type
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Leave Type
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Leave Type Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>
                                  {userPermissions.indexOf("leavetype-edit") !== -1 ? (
                                    <StatusBadge
                                      item={item}
                                      api={LeaveTypeService.updateStatusLeaveType}
                                    />
                                  ) : (
                                    <>
                                      {item.status === "1" ? (
                                        <span className="badge bg-success text-white">Active</span>
                                      ) : (
                                        <span className="badge bg-danger text-white">Deactive</span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("leavetype-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelEdit(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editLeaveTypeModal"
                                    >
                                      <Tooltip title="Edit Leave Type">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-pen iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to edit"
                                    />
                                  )}
                                  {userPermissions.indexOf("leavetype-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Leave Type">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-trash iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to delete"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Add your first leave type by clicking the 'Create Leave Type' button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {leaveTypeList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={leaveTypeList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteLeaveTypeModal" data-bs-toggle="modal" data-bs-target="#deleteLeaveTypeModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteLeaveTypeModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Leave Type</h5>
                <button type="button" className="btn-close" id="closeLeaveTypeDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this leave type?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create modal */}
        <div
          id="createLeaveTypeModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelCreate(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Leave Type</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="createmodalclose"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="Name"
                      placeholder=" "
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="Name">Leave Type Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}
                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                    <span style={{ fontSize: "13px", color: "#555", minWidth: "48px" }}>Status</span>
                    <div className="form-check form-switch form-switch-md mb-0" dir="ltr">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="customSwitchsizemd"
                        onChange={onStatusChange}
                        checked={status}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="submit"
                    onClick={(e) => handelCreate(e)}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Leave Type
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit modal */}
        <div
          id="editLeaveTypeModal"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={(e) => handelEditSubmit(e)}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Leave Type</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="editmodalclose"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap mb-3">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="editName"
                      placeholder=" "
                      value={editName}
                      onChange={(e) => {
                        setEditName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="editName">Leave Type Name*</label>
                  </div>
                  {error && <small className="text-danger d-block mb-2">{error}</small>}
                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                    <span style={{ fontSize: "13px", color: "#555", minWidth: "48px" }}>Status</span>
                    <div className="form-check form-switch form-switch-md mb-0" dir="ltr">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="editSwitch"
                        onChange={onEditStatusChange}
                        checked={editStatus || false}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={(e) => handelEditSubmit(e)}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default LeaveType;
